<template>
  <div>
    <md-steppers md-alternative @md-changed="stepTaken">
      <md-step id="first" :md-label="startDateTitle">
        <md-datepicker
          v-model="startDate"
          md-immediately
          :md-disabled-dates="disabledStartDates"
          class="hide-input-clear-x"
          id="moveInDatepicker"
        >
          <label>{{startDateTitle}}</label>
        </md-datepicker>
      </md-step>

      <md-step id="second" :md-label="endDateTitle">
        <md-datepicker
          v-model="endDate"
          md-immediately
          :md-disabled-dates="disabledEndDates"
          class="hide-input-clear-x"
          id="moveOutDatepicker"
        >
          <label>{{endDateTitle}}</label>
        </md-datepicker>
        <md-button @click="finish()" class="md-primary play-cta-button makeup">Done</md-button>
      </md-step>
    </md-steppers>
  </div>
</template>

<script>
const lists = require("@/lists.js");
import { dayPossibleInMonth } from "@/timeFunctions.js";
export default {
  props: {
    startDateTitle: {
      type: String,
      default: "Start Date"
    },
    endDateTitle: {
      type: String,
      default: "End Date"
    },
    disabledStartDates: {
      type: Function
    },
    disabledEndDates: {
      type: Function
    }
  },

  components: {},
  data() {
    return {
      startDate: "",
      endDate: ""
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.autoClickOnInput("moveInDatepicker");
  },
  created() {},
  methods: {
    stepTaken(stepId) {
      console.log("stepTaken to:", stepId);
      if (stepId == "second") this.autoClickOnInput("moveOutDatepicker");
    },
    finish() {
      this.$emit("emitFinish", { startDate: startDate, endDate: endDate });
    },
    autoClickOnInput(inputContainerId) {
      let inputContainer = document.getElementById(inputContainerId);
      inputContainer.click()
          console.log("clicked on:", inputContainer);

    //   for (let i = 0; i < inputContainer.childNodes.length; i++) {
    //     const child = inputContainer.childNodes[i];
    //     if (child.tagName == "INPUT") {
    //       console.log("child:", child);
    //       child.click();
    //       console.log("clicked!");
    //       return;
    //     }
    //   }
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/utils/rollingPeriodDatePicker.vue